import React from "react";
import PropTypes from "prop-types";
import InTransitRecoveryGlobal from '../InTransitRecovery/globalView/inTransitRecoveryGlobal';

const UnloadingPriorityLossToAction = ({sideViewTab}) => {
    return (   
        <InTransitRecoveryGlobal sideViewTab={sideViewTab}/>  
    );
};

UnloadingPriorityLossToAction.propTypes = {
    sideViewTab: PropTypes.string,
};

export default UnloadingPriorityLossToAction;